import api from '@/api/common/class.js'
const state = {
}
const mutations = {
}
const actions = {
}	
// orderReward({}, params = {}) {
//         return api.orderReward(params)
//     }
for (const key in api) {
    actions[key] = async ({commit}, params = {}) => {
        if(api[key].mutationsName) {
            let res = await api[key].requestFun(params)
            commit(api[key].mutationsName, res)
        } else {
            return api[key].requestFun(params)
        }
    }
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}